import { combineReducers } from '@reduxjs/toolkit'

import { reducer as team } from '../../redux/team'
import lineups from './lineups'

const reducer = combineReducers({
  lineups,
  team,
})

export default reducer
